import React from 'react';
import { Fragment } from 'react';
import ToolBarMenu from '../../components/ToolBarMenu/index';
import Header from '../../components/Header/index';
import PageHeader from '../../components/PageHeader/index';
import Footer from '../../components/Footer/index';
import { useCareers } from '../../queries/Careers';
import { useColleagues } from './../../queries/colleagues';
import {getImagesWithAbsolutePath, myDomain} from '../../helpers/urlHelper';
import { useColleaguePageHeader } from './../../queries/colleaguePageHeader';
import InfinitProgressBar from '../../components/InfiniteProgressBar';
const Colleagues = () => {
    
    const {data, error, loading} = useColleagues()
    const colPage = useColleaguePageHeader();

    if(colPage.loading) return <InfinitProgressBar/>
    if(colPage.error) return <div>error!</div>

    // if (error) return <div>error!</div>
    // if (loading) return <InfinitProgressBar/>
console.log(data);
    return (  data ?
        <Fragment>
            {/* <ToolBarMenu/> */}
            <Header/>
            <PageHeader
                bgImg={colPage.data.colleaguesPageHeader[0].colleaguesPageHeaderImage.urls[0]}
                title={colPage.data.colleaguesPageHeader[0].displayText}
                content={colPage.data.colleaguesPageHeader[0].colleaguesPageHeaderSubtitle.html}
            />
            <div style={{padding:"2% 10%", lineHeight:"30px"}} dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(data.colleagues[0].htmlBody.html, myDomain)}} />
            <br/>
            <br/>
            <br/>
            <Footer/>
        </Fragment>
    : null);
}
 
export default Colleagues;